{
  "INTEGRATION_APPS": {
    "FETCHING": "Preluarea integrărilor",
    "NO_HOOK_CONFIGURED": "Nu există integrări {integrationId} configurate în acest cont.",
    "HEADER": "Aplicatii",
    "STATUS": {
      "ENABLED": "Activat",
      "DISABLED": "Dezactivat"
    },
    "CONFIGURE": "Configurare",
    "ADD_BUTTON": "Adăugați un cârlig nou",
    "DELETE": {
      "TITLE": {
        "INBOX": "Confirmă ștergerea",
        "ACCOUNT": "Deconectare"
      },
      "MESSAGE": {
        "INBOX": "Sigur doriți să ștergeți?",
        "ACCOUNT": "Sunteți sigur că vă deconectați?"
      },
      "CONFIRM_BUTTON_TEXT": {
        "INBOX": "Da, șterge",
        "ACCOUNT": "Da, Deconectați-vă"
      },
      "CANCEL_BUTTON_TEXT": "Renunță",
      "API": {
        "SUCCESS_MESSAGE": "Cârlig șters cu succes",
        "ERROR_MESSAGE": "Nu s-a putut conecta la Woot Server, încercați din nou mai târziu"
      }
    },
    "LIST": {
      "FETCHING": "Preluarea cârligelor de integrare",
      "INBOX": "Inbox",
      "EDIT": {
        "BUTTON_TEXT": "Editează"
      },
      "DELETE": {
        "BUTTON_TEXT": "Şterge"
      }
    },
    "ADD": {
      "FORM": {
        "INBOX": {
          "LABEL": "Selectați Inbox",
          "PLACEHOLDER": "Selectați Inbox"
        },
        "SUBMIT": "Creeaza",
        "CANCEL": "Renunță"
      },
      "API": {
        "SUCCESS_MESSAGE": "Regulă de automatizare adăugată cu succes",
        "ERROR_MESSAGE": "Nu s-a putut conecta la Woot Server, încercați din nou mai târziu"
      }
    },
    "EDIT": {
      "TITLE": "Editează {name}",
      "FORM": {
        "INBOX": {
          "LABEL": "Selectați inbox",
          "PLACEHOLDER": "Selectați inbox"
        },
        "SUBMIT": "Actualizează",
        "CANCEL": "Anulează"
      },
      "API": {
        "SUCCESS_MESSAGE": "Integrarea a fost actualizată cu succes",
        "ERROR_MESSAGE": "Nu s-a putut conecta la serverul de chat. Vă rugăm să încercați din nou mai târziu"
      }
    },
    "CONNECT": {
      "BUTTON_TEXT": "Conectează-te"
    },
    "DISCONNECT": {
      "BUTTON_TEXT": "Deconectare"
    },
    "SIDEBAR_DESCRIPTION": {
      "CUSTOM_DATA_PROVIDER": "Preia date de pe propriul server și afișează-le în bara laterală a conversației. Returnează HTML (afișat într-un iframe) sau JSON (afișat ca listă cheie/valoare).",
      "DIALOGFLOW": "Dialogflow is a natural language processing platform for building conversational interfaces. Integrating it with {installationName} lets bots handle queries first and transfer them to agents when needed. It helps qualify leads and reduce agent workload by answering FAQs. To add Dialogflow, create a Service Account in Google Console and share the credentials. Refer to the docs for details",
      "DAKTELA": "Sincronizați emailurile și chaturile web cu contul dumneavoastră daktela.",
      "RETINO": "Retino aduce ordine în gestionarea returnărilor și reclamațiilor.",
      "MAILSHIP": "Mailship este un sistem de gestionare a depozitelor și livrării comenzilor. Consultați starea comenzilor, urmărirea și detaliile expedierii.",
      "RAYNET": "Conectați-vă contul Raynet CRM pentru a accesa datele clienților. Adăugați o conexiune cu numele de utilizator și tokenul API Raynet."
    },
    "TEST_CONNECTION": {
      "BUTTON": "Testează conexiunea",
      "SUCCESS": "Conexiune reușită",
      "ERROR": "Conexiunea a eșuat. Vă rugăm să verificați datele de autentificare."
    }
  }
}
